import * as Api from './Api';
import { useEffect, useRef, useState } from 'react';

const MAX_RUNS = 240;
const CHECKING_INTERVAL_SECONDS = 2;

const useBackgroundTaskResults = (token, onSuccess) => {
    const [status, setStatus] = useState('');
    const [results, setResults] = useState();
    const [error, setError] = useState();
    const [id, setId] = useState();
    const activeTokenRef = useRef(null);

    function checkResults(numRuns, forToken) {
        if (forToken !== activeTokenRef.current) {
            return;
        }

        Api.get(`/api/background-task-results/${forToken}`).then(result => {
            if (forToken !== activeTokenRef.current) return;

            setStatus(result.status);
            setResults(result.results);
            setError(result.error);
            setId(result.id);

            if (result.status === 'success' && onSuccess) {
                onSuccess(result.results);
            }

            if (
                (result.status === 'running' || result.status === 'pending') &&
                numRuns < MAX_RUNS
            ) {
                setTimeout(
                    () => checkResults(numRuns + 1, forToken),
                    CHECKING_INTERVAL_SECONDS * 1000,
                );
            }
        });
    }

    function reset() {
        activeTokenRef.current = null;
        setStatus('');
        setResults(undefined);
        setError(undefined);
        setId(undefined);
    }

    useEffect(() => {
        if (token) {
            activeTokenRef.current = token;
            setTimeout(() => checkResults(0, token), CHECKING_INTERVAL_SECONDS * 1000);
            setStatus('pending');
        }
    }, [token]);

    return {
        status,
        results,
        error,
        id,
        reset,
    };
};

export default useBackgroundTaskResults;
